import CryptoJS from 'crypto-js';

export default {
    install: (app) => {
        app.config.globalProperties.$CryptoJS = CryptoJS;
    }
};
